// servicios/actualizacionDiaria.js
import { supabase } from "../supabase";
import {
  sincronizarTodosLosProyectos,
  sincronizarPresupuestosProyecto,
} from "./actualizacionPresupuestos";

class ServicioActualizacionDiaria {
  constructor() {
    this.intervalId = null;
    this.isRunning = false;
  }

  // Función principal de actualización diaria
  async ejecutarActualizacionDiaria() {
    try {
      console.log("🌅 Iniciando actualización diaria de presupuestos...");

      const inicio = Date.now();
      const resultados = await sincronizarTodosLosProyectos();
      const duracion = Date.now() - inicio;

      console.log(`✅ Actualización diaria completada en ${duracion}ms`);
      console.log(
        `📊 Resultados: ${resultados.exitosos} exitosos, ${resultados.fallidos} fallidos`
      );

      if (resultados.errores && resultados.errores.length > 0) {
        console.warn("⚠️ Errores encontrados:", resultados.errores);
      }

      return resultados;
    } catch (error) {
      console.error("❌ Error en actualización diaria:", error);
      return { success: false, error: error.message };
    }
  }

  // Función para actualización manual de un proyecto específico
  async ejecutarActualizacionManual(proyectoId, constructoraId) {
    try {
      console.log(
        `🔄 Ejecutando actualización manual del proyecto ${proyectoId}`
      );

      const resultado = await sincronizarPresupuestosProyecto(
        proyectoId,
        constructoraId
      );

      if (resultado.success) {
        console.log(`✅ Proyecto ${proyectoId} actualizado manualmente`);
      } else {
        console.error(
          `❌ Error actualizando proyecto ${proyectoId}:`,
          resultado.error
        );
      }

      return resultado;
    } catch (error) {
      console.error("❌ Error en actualización manual:", error);
      return { success: false, error: error.message };
    }
  }

  // Programar actualización diaria a las 2 AM
  programarActualizacionDiaria() {
    if (this.isRunning) {
      console.log("📅 Actualización diaria ya está programada");
      return;
    }

    // Calcular tiempo hasta las 2 AM
    const ahora = new Date();
    const proximaEjecucion = new Date();
    proximaEjecucion.setHours(2, 0, 0, 0); // 2:00 AM

    // Si ya pasaron las 2 AM hoy, programar para mañana
    if (proximaEjecucion <= ahora) {
      proximaEjecucion.setDate(proximaEjecucion.getDate() + 1);
    }

    const tiempoHasta2AM = proximaEjecucion.getTime() - ahora.getTime();

    console.log(
      `📅 Programando primera actualización para: ${proximaEjecucion.toLocaleString()}`
    );

    // Programar primera ejecución
    setTimeout(() => {
      this.ejecutarActualizacionDiaria();

      // Luego ejecutar cada 24 horas
      this.intervalId = setInterval(() => {
        this.ejecutarActualizacionDiaria();
      }, 24 * 60 * 60 * 1000); // 24 horas
    }, tiempoHasta2AM);

    this.isRunning = true;
    console.log("✅ Actualización diaria programada");
  }

  // Detener la programación
  detenerActualizacionDiaria() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.isRunning = false;
    console.log("🛑 Actualización diaria detenida");
  }

  // Verificar estado
  obtenerEstado() {
    return {
      isRunning: this.isRunning,
      intervalId: this.intervalId,
      proximaEjecucion: this.isRunning
        ? "Programada para 2:00 AM diariamente"
        : "No programada",
    };
  }
}

// Crear instancia única
export const servicioActualizacionDiaria = new ServicioActualizacionDiaria();
